import React, { FunctionComponent } from "react"
import { FormControl } from "react-bootstrap"
import ratmService from "../../../utils/RATMService"
import RoleTemplatePortalRoleLnkHashTableTypes from "../../../types/hashTableTypes/RoleTemplatePortalRoleLnkHashTableTypes"
import ratmHash from "../../../utils/RATMHash"
import PortalRoleTypes from "../../../types/portalRoleTypes/PortalRoleTypes"
import HandleAddOrDropEditOrViewInTemplate from "../../../utils/HandleAddOrDropEditOrViewInTemplate"
import RoleTemplatePortalRoleLinkPermissionsBoiler from "../../../utils/boilerPlates/templateBoilerplates/RoleTemplatePortalRoleLinkPermissionsBoiler"
import generateClassNames from "../../../utils/GenerateClassNames"
import "./TemplateManagementTablePermissionControls.css"

interface Props {
    role: PortalRoleTypes
}

const TemplateManagementTablePermissionControls: FunctionComponent<Props> = (props) => {

    const { role } = props

    const { lookupHashTableItem } = ratmHash

    const { manageState } = ratmService

    const linkedFromHash: RoleTemplatePortalRoleLnkHashTableTypes = lookupHashTableItem(role.PortalRoleId, 2)

    const permissions = linkedFromHash ? linkedFromHash[2].permissions : { ...RoleTemplatePortalRoleLinkPermissionsBoiler }

    const disabled = permissions.dropRole || (!permissions.hasRole && !permissions.addRole)

    return (
        <div className={`TemplateManagementTablePermissionControls ${disabled ? "TemplateManagementTablePermissionControlsDisabled" : "TemplateManagementTablePermissionControlsNotDiabled"}`}>
            <div className={`TemplateManagementTablePermissionControlsBtn ${generateClassNames(role.PortalRoleId, "TemplateManagementTablePermissionControlsBtn", "hasView", "addView", "dropView", disabled)}`}
                onClick={() => {
                    if (!disabled) {
                        HandleAddOrDropEditOrViewInTemplate(role, "View")
                        manageState([])
                    }
                }}
            >
                <div className="TemplateManagementTablePermissionControlsBtnCheckbox">
                    <FormControl
                        onChange={() => null}
                        checked={((permissions.hasView && !permissions.dropView && !disabled) || permissions.addView)}
                        type="checkbox"
                        disabled={disabled}
                    />
                </div>
                <p>View</p>
            </div>
            <div className={`TemplateManagementTablePermissionControlsBtn ${generateClassNames(role.PortalRoleId, "TemplateManagementTablePermissionControlsBtn", "hasEdit", "addEdit", "dropEdit", disabled)}`}
                onClick={() => {
                    if (!disabled) {
                        HandleAddOrDropEditOrViewInTemplate(role, "Edit")
                        manageState([])
                    }
                }}
            >
                <div className="TemplateManagementTablePermissionControlsBtnCheckbox">
                    <FormControl
                        onChange={() => null}
                        checked={((permissions.hasEdit && !permissions.dropEdit && !disabled) || permissions.addEdit)}
                        type="checkbox"
                        disabled={disabled}
                    />
                </div>
                <p>Edit</p>
            </div>
        </div>
    )
}

export default TemplateManagementTablePermissionControls